export default __webpack_public_path__ + "static/media/Gujarati 15th Finance Commission related Circular.1f262f2e.pdf";